// extracted by mini-css-extract-plugin
module.exports = {"detail-page-with-sticky-header":"detail-page-with-sticky-header_detail-page-with-sticky-header__ybWEj"};